import { action } from 'easy-peasy';
import { IActionSetClientAllocationAvailability } from '../types';

const setClientAllocationAvailability: IActionSetClientAllocationAvailability = action(
  (state, payload) => {
    state.dateAvailability = payload;
  },
);

export default setClientAllocationAvailability;
